<!-- The open line's hidden columns: their editors, out of sight, as the old grid had them. Drawn before the grid so
     the visible cells' editors can read them when they open. -->
@if (hiddenEditRow) {
    <div class="d-none" aria-hidden="true">
        @for (field of hiddenEditFields; track field) {
            <app-cell-editor [edit]="editDef(field)" [field]="field" [rowData]="hiddenEditRow" [registry]="openEditors" />
        }
    </div>
}

<!-- Claim lines on @inavista/components: rows are the claim form's iscClaimDetails (LocalRowsGridApi); each editable cell
     shows its column's own editor (lineEditor templates below), so the editors' rules run as before. -->
@if (gridConfig) {
    <div class="claim-lines-grid">
        <inavista-grid #claimsGrid
            [config]="gridConfig"
            [actionIcons]="actionIcons"
            (rowEditStart)="onEditStart($event)"
            (rowCommit)="onCommit($event)"
            (rowRevert)="onRevert($event)"
            (actionIconClick)="onActionIconClick($event)"
            (hyperlinkClick)="onHyperlink($event)"
            (toolbarActionClick)="onToolbarAction($event)"
            (exportRequested)="onExportRequested()" />
    </div>
}

<!-- One template per editable column, drawn with its editor (CellEditorHost, @inavista/components controls). -->
@for (field of editFields; track field) {
    <ng-template #lineEditor let-row>
        <app-cell-editor [edit]="editDef(field)" [field]="field" [rowData]="lineFor(row)" [registry]="openEditors" />
    </ng-template>
}

@if (showItemAdvancedSearchPopup) {
    <app-items-advanced-search
        [technicianId]="claimsForm.value?.technicianId"
        [serviceItemGroup]="serviceItemGroup"
        (onClose)="onItemAdvancedSearchPopupClose($event)"
    ></app-items-advanced-search>
}
